import { FormInput } from "@/shared/ui/form-input"
import { Modal } from "@/shared/ui/modal"
import { closeUpdateUserIntegrationModal, fetchUpdateUserIntegration, selectIsUpdateUserIntegrationModalOpen, selectOnUpdate, updateUserIntegrationSchema } from "../../model"
import { yupResolver } from "@hookform/resolvers/yup"
import { SubmitHandler, useForm } from "react-hook-form"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { useEffect } from "react"
import { selectCurrentIntegration } from "../../model/selectors"

interface UpdateUserIntegrationFormValues {
    callback_url: string
}

const initialState: UpdateUserIntegrationFormValues = {
    callback_url: ""
}

export const UpdateUserIntegrationModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsUpdateUserIntegrationModalOpen)
    const onUpdate = useAppSelector(selectOnUpdate)
    const integration = useAppSelector(selectCurrentIntegration)

    useEffect(() => {
        reset({
            callback_url: integration.callback_url
        })
    }, [integration])

    const handleClose = () => {
        dispatch(closeUpdateUserIntegrationModal())
    }

    const onSubmit: SubmitHandler<typeof initialState> = async (data) => {
        await new Promise((res, rej) => {
            dispatch(fetchUpdateUserIntegration({
                callback_url: data.callback_url
            }))
                .unwrap()
                .then(() => {
                    notify.success('Пользовательская интеграция успешно изменена')
                    reset()
                    onUpdate?.()
                    handleClose()
                    res('')
                })
                .catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
        reset
    } = useForm({
        defaultValues: initialState,
        resolver: yupResolver(updateUserIntegrationSchema)
    })

    return (
        <Modal
            isOpen={isOpen}
            title={(
                <div>
                    Изменение <br />
                    Пользовательской <br />
                    Интеграции
                </div>
            )}
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <FormInput
                    register={register}
                    label={"Адрес обратного вызова"}
                    id={"callback_url"}
                    error={errors['callback_url']}
                    required={true}
                    placeholder="Введите адрес обратного вызова"
                />
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Сохранить
                    </button>
                </div>
            </form>
        </Modal>
    )
}